import { FC, useMemo } from 'react'

import {
  ExonNotification,
  readNotifications,
  ItdFlexibleStatus,
} from '@builddocs/data-management'
import { ListItemText, Typography, Stack } from '@mui/material'
import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'
import { useNavigate } from 'react-router-dom'

interface OwnProps {
  notification: ExonNotification
  onClosePopover: () => void
  refetch: () => void
}

export const ExonNotificationAct: FC<OwnProps> = props => {
  const { notification, onClosePopover, refetch } = props

  const navigate = useNavigate()

  const { exonEventModel, notificationTargetId, createDateTime, viewed } =
    notification

  const urlMatches = /projects\/([\d\w-]+)\/contracts\/([\d\w-]+)\//gi.exec(
    exonEventModel.actLocationUrl,
  )

  const eventProjectId = urlMatches?.[1]
  const eventContractId = urlMatches?.[2]

  const actDateString = format(parseISO(exonEventModel.actDate), 'PP', {
    locale: ru,
  })
  const searchParams: string = useMemo(
    () => (notification.exonEventModel.closed ? 'closings' : 'drafts'),
    [notification],
  )

  const goToActPage = () => {
    if (eventProjectId && eventContractId) {
      onClosePopover()
      readNotifications([notificationTargetId]).then(() => refetch())
      navigate({
        pathname: `/projects/${eventProjectId}/contracts/${eventContractId}/acts`,
        search: `?select=${searchParams}`,
      })
    }
  }

  const formattedText = () => {
    switch (exonEventModel.exonStatusType) {
      case ItdFlexibleStatus.NEW:
        return 'сформирован в ГИС'
      case ItdFlexibleStatus.ON_APPROVAL:
        return 'на проверке в ГИС'
      case ItdFlexibleStatus.SIGNED:
        return 'подписан в ГИС'
      case ItdFlexibleStatus.CANCELED:
        return 'аннулирован в ГИС'
      case ItdFlexibleStatus.REVISION:
        return 'на доработке в ГИС'
      case ItdFlexibleStatus.REVISION_FROM_SIGN:
        return 'на доработке после подписания в ГИС'
      case ItdFlexibleStatus.SIGNED_AND_APPROVED:
        return 'подписан и согласован в ГИС'
      default:
        return 'изменил статус'
    }
  }

  return (
    <Stack
      alignItems="center"
      direction="row"
      spacing={2}
      onClick={goToActPage}
    >
      <ListItemText
        disableTypography
        primary={
          <Typography
            component="span"
            fontWeight={viewed ? 'normal' : 'bold'}
            whiteSpace="break-spaces"
          >
            {`Акт №${
              exonEventModel.actNumber
            } от ${actDateString} ${formattedText()}`}
          </Typography>
        }
        secondary={
          <>
            <Typography color="text.secondary" whiteSpace="break-spaces">
              {`в разделе ${exonEventModel.workDocSection} объекта ${exonEventModel.journalTitle}`}
            </Typography>
            <Typography
              color="text.secondary"
              variant="caption"
              whiteSpace="nowrap"
            >
              {format(parseISO(createDateTime), 'p, PPP', {
                locale: ru,
              })}
            </Typography>
          </>
        }
      />
    </Stack>
  )
}
